import {
  applyTagsLookupToProductOptionGroups,
  buildOptionTagsLookup,
  getNewMenuOptionGroups,
} from '../../../helpers/product';
import {
  filterApiOptionGroups,
  type MenuVisibilityStoreConfig,
} from '../../../helpers/menuVisibility';
import axiosInstance from '../../axiosInceptor';

export type ProductModifiersFilterContext = {
  chainProductId: number;
  visibility: MenuVisibilityStoreConfig | null;
};

export const getProductOption = (
  id: number,
  filterCtx?: ProductModifiersFilterContext,
) => {
  try {
    const url = process.env.REACT_APP_OLO_API || '';
    return axiosInstance
      .get(url + `/products/${id}/modifiers?includedisabled=false`)
      .then((response) => {
        const data = response.data;
        if (
          filterCtx?.visibility &&
          data?.optiongroups &&
          filterCtx.chainProductId != null
        ) {
          data.optiongroups = filterApiOptionGroups(
            data.optiongroups,
            filterCtx.chainProductId,
            filterCtx.visibility,
          );
        }
        return data;
      })
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};

export const getProductOptionNew = (
  id: number,
  selectedIds?: number[],
  filterCtx?: ProductModifiersFilterContext,
) => {
  try {
    const url = process.env.REACT_APP_OLO_API || '';
    return axiosInstance
      .get(url + `/products/${id}/modifiers?includedisabled=false`)
      .then((response) => {
        let optiongroups = response.data.optiongroups;
        if (
          filterCtx?.visibility &&
          optiongroups &&
          filterCtx.chainProductId != null
        ) {
          optiongroups = filterApiOptionGroups(
            optiongroups,
            filterCtx.chainProductId,
            filterCtx.visibility,
          );
        }
        const tagsLookup = buildOptionTagsLookup(optiongroups);
        const simplified = getNewMenuOptionGroups(optiongroups, selectedIds);
        return {
          ...simplified,
          options: applyTagsLookupToProductOptionGroups(
            simplified.options,
            tagsLookup,
          ),
        };
      })
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};

export type UpsellItemProductOptionGroup = {
  options: any[];
  mandatory: boolean;
};

/** Parallel GET modifiers for upsell products; first optiongroup’s options + mandatory per id. */
export async function fetchUpsellItemProductOptions(
  productOptionsIds: number[],
): Promise<Record<string, UpsellItemProductOptionGroup>> {
  const url = process.env.REACT_APP_OLO_API || '';
  const promises = productOptionsIds.map((productOptionsId) =>
    axiosInstance.get(
      `${url}/products/${productOptionsId}/modifiers?includedisabled=false`,
    ),
  );
  const responses = await Promise.all(promises);
  const options: Record<string, UpsellItemProductOptionGroup> = {};

  responses.forEach((response, index) => {
    const productOptionId = productOptionsIds[index];
    const productOption = response.data;
    let productOptions: any[] = [];
    let mandatory = false;
    if (
      productOption &&
      !productOption.error &&
      productOption.optiongroups &&
      productOption.optiongroups.length > 0
    ) {
      productOptions = productOption.optiongroups[0]?.options ?? [];
      mandatory = productOption.optiongroups[0]?.mandatory ?? false;
    }
    options[String(productOptionId ?? 0)] = {
      options: productOptions,
      mandatory,
    };
  });

  return options;
}
